import { BeLinkHttp } from '@be-link/http';

export const beLinkHttp = new BeLinkHttp();

export function initHttp(baseURL: string) {
	beLinkHttp.init({ baseURL });
}
